<script setup>
import {ErrorMessage, Field, Form} from 'vee-validate'
import {reactive, ref} from 'vue'
import axios from 'axios'
import {useFormSubmit} from '../../composables/useFormSubmit'

const { showServerSideValidateErrors, enquirySubmitDataLayer, sendFBLeadData } = useFormSubmit()
const props = defineProps({
  postUrl: {
    type: String,
    default: '',
  },
  textareaPlaceholder: {
    type: String,
    default: '',
  },
})

const schema = {
  first_name: 'required',
  last_name: 'required',
  email: 'required|email',
  phone_number: 'required|phoneNumber',
}

let isSubmitting = ref(false)
const confirmation = reactive({show: false, message: '', class: ''})

const onSubmit = async () => {
  isSubmitting.value = true
  confirmation.show = true
  confirmation.class = 'message--warning'
  confirmation.message = 'Submitting....'
  const form  = document.getElementById('careHomeFreeContactForm');
  let formData = new FormData(form);
  window.grecaptcha.execute(document.getElementById('mySiteKeyVariable').value, {
    action: formData.get('captcha_action'),
  }).then((token) => {
    const submitButton = form.querySelector('.submit');
    submitButton.disabled = true;
    formData.set('g-recaptcha-response', token);
    axios.post('/enquiry-submitted', formData).then(function (response) {
      confirmation.class = 'message--success'
      confirmation.message = response.data.msg
      enquirySubmitDataLayer(form);
      sendFBLeadData(formData.get('subject'));
      let currentUrl = window.location.href;
      currentUrl = currentUrl.replace('#enquiry-submitted', '');
      history.pushState(null, null, `${currentUrl}#enquiry-submitted`);

      setTimeout(function () {
        confirmation.show = false;
      }, 4000);
    }).catch(error => {
      submitButton.disabled = false;
      showServerSideValidateErrors(error, isSubmitting, confirmation)
    });
  });
}

</script>

<template>
  <Form
    :validation-schema="schema"
    v-slot="{ errors }"
    @submit="onSubmit"
    id="careHomeFreeContactForm"
  >
    <slot name="token"></slot>
    <div class="form-group form-group--input mb-5 pt-3">
      <label for="first_name">First name <span class="text-red">*</span></label>
      <Field
        id="first_name"
        name="first_name"
        class="form-control"
        :class="{'is-danger': errors['first_name'] }"
      />
      <ErrorMessage name="first_name" class="is-danger" />
    </div>
    <div class="form-group form-group--input mb-5">
      <label for="last_name">Last name <span class="text-red">*</span></label>
      <Field
        name="last_name"
        class="form-control"
        :class="{'is-danger': errors['last_name'] }"
        id="last_name"
      />
      <ErrorMessage name="last_name" class="is-danger" />
    </div>
    <div class="form-group form-group--input mb-5">
      <label for="email">Email <span class="text-red">*</span></label>
      <Field
        id="email"
        name="email"
        class="form-control"
        :class="{'is-danger': errors['email'] }"
      />
      <ErrorMessage name="email" class="is-danger" />
    </div>
    <div class="form-group form-group--input mb-5">
      <label for="phone_number">Phone <span class="text-red">*</span></label>
      <Field
        id="phone_number"
        name="phone_number"
        class="form-control"
        :class="{'is-danger': errors['phone_number'] }"
      />
      <ErrorMessage name="phone_number" class="is-danger" />
    </div>
    <div class="form-group form-group--input mb-5">
      <label for="comment">Message</label>
      <textarea
        id="message"
        rows="6"
        class="form-control"
        name="message"
        :placeholder="textareaPlaceholder"
      ></textarea>
    </div>
    <input type="hidden" name="captcha_action" value="care_home_enquiry">
    <transition name="fade">
      <div :class="confirmation.class" class="message" v-if="confirmation.show">{{ confirmation.message }}</div>
    </transition>
    <slot name="hiddenfields"></slot>
    <div class="row pt-4">
      <div class="col-lg-12 text-center">
        <input type="submit" value="Send Message" class="btn btn--green btn--auto-width fs-20 submit">
      </div>
    </div>
    <div class="mb-8">
      <slot name="googlerecaptchatext"></slot>
    </div>
  </Form>
</template>
